<template>
  <div v-if="returnOrder && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint
      :formater="formater"
      :data="returnOrder"
    />
  </div>
</template>
<script>
import ReturnOrders from "@/api/return_orders";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    returnOrder: {},
  }),

  mounted() {
    PrintTemplates.fetchOne("orderReturn").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          ReturnOrders.returnOrderPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.returnOrder = response.data.return_order;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>